var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer"},[(!_vm.finish_timer)?_c('div',[_c('span',{staticClass:"timer-text"},[_vm._v(" Получить новый код можно ")]),_c('span',{staticClass:"time"},[_c('span',{staticClass:"seconds"},[_vm._v(" через "+_vm._s(_vm.seconds))]),_vm._v(" сек ")])]):_c('ButtonLink',{attrs:{"text":"Получить новый код","callback":_vm.startTimer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }